import React from 'react';
import { Notification, Typography } from '@drone-js/core';
import OfferChip from 'component/page/detail/PackageOptions/ExpandedOffer/OfferChip/OfferChip';
import { getTimeSlotSpecification, isOfferOptionAvailable } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferOptions/OfferOptionsUtils';
import { MappedOfferOptionKey } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferOptions/OfferOptions.types';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { Specification } from 'gql/autogen/Specification';
import { EnrichedOfferOption } from 'gql/autogen/EnrichedOfferOption';
import { useSelector } from 'react-redux';
import { selectScreenSize } from 'store/slice/screen';
import { LeanScrollbarBox } from 'component/common/LeanScrollBarBox.styled';

interface TimeSpecificationProps {
    timeSpecification?: MappedOfferOptionKey;
    cms: CmsValue;
    isSelected: (specification: Specification) => boolean;
    isShowTimeSlotNotification: boolean;
    onSelected: (specification: Specification, index?: number, isRadio?: boolean) => void;
    allOfferOptions: EnrichedOfferOption[];
    selectedSpecifications: Specification[];
    selectedOfferId: number;
    activityId: number | undefined;
}

const TimeSpecification: React.FC<TimeSpecificationProps> = (props) => {
    const screenSize = useSelector(selectScreenSize);
    const { timeSpecification, cms, isSelected, isShowTimeSlotNotification, onSelected, allOfferOptions, selectedSpecifications, selectedOfferId, activityId } = props;

    if (!timeSpecification) {
        return null;
    }

    return (
        <>
            <Typography variant="body-s-strong" tag="h5">
                {cms[231788]}
            </Typography>
            {isShowTimeSlotNotification && (
                <Notification
                    data-element-name="activities-time-slot-notification"
                    intent="warning"
                    title={props.cms[305874]}
                    asset={{ id: 'fill.symbol.circle-info' }}
                    radius="m"
                />
            )}
            <LeanScrollbarBox
                display="flex"
                justifyContent="flex-start"
                flexWrap="wrap"
                data-testid="offer-options-timeslot-container"
                maxHeight={screenSize.mobile ? '9.5em' : '18em'}
                overflowY="auto"
                pt="4"
                pb="12"
                px="4"
                overflowX="hidden"
                DEPRECATED_gap="10px"
            >
                {timeSpecification.values.map((timeOption, id) => (
                    <OfferChip
                        key={timeOption}
                        isOfferSelected={isSelected(getTimeSlotSpecification(timeOption))}
                        id={id ?? -1}
                        onTimeSelected={() => onSelected(getTimeSlotSpecification(timeOption))}
                        isOfferAvailable={isOfferOptionAvailable(allOfferOptions, selectedSpecifications, getTimeSlotSpecification(timeOption))}
                        isEnableOfferGrouping={true}
                        startTime={timeOption}
                        selectedOfferId={selectedOfferId}
                        activityId={activityId}
                    />
                ))}
            </LeanScrollbarBox>
        </>
    );
};

TimeSpecification.displayName = 'TimeSpecification';

export default TimeSpecification;
